import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ProviderMappings from './ProviderMappings';
import VetdataRevenueMappings from './VetdataRevenueMappings';
import EzyVetRevenueMappings from './EzyVetRevenueMappings';
import VetspireRevenueMappings from './VetspireRevenueMappings';

export default class Mappings extends Component {
    constructor() {
        super();

        this.state = {
            selectedFile: "",
            load: false,
            importFile: { fileBytes: "" },
            importProcessed: false,
            loadingMappings: false,
            loadingSummary: false,
            mismappingsTable: [],
            mismappingCount: "",
            mappingViewTabs: [],
            selectedTab: "Provider Mapping"
        };
    }

    renderTabs = () => {
        let tabsToRender = [];
        tabsToRender.push(<Tab label="Provider Mapping" key="ProviderMapping" value="Provider Mapping" />);
        tabsToRender.push(<Tab label="Vetdata Revenue Mapping" key="VetdataRevenueMapping" value="Vetdata Revenue Mapping" />);
        tabsToRender.push(<Tab label="EzyVet Revenue Mapping" key="EzyvetRevenueMapping" value="EzyVet Revenue Mapping" />);
        tabsToRender.push(<Tab label="Vetspire Revenue Mapping" key="VetspireRevenueMapping" value="Vetspire Revenue Mapping" />);

        let selectedTab = this.state.selectedTab;

        return (
            <Tabs value={selectedTab} onChange={(event, value) => this.setState({ selectedTab: value })}>
                {tabsToRender.map((value) => value)}
            </Tabs>
        );
    }

    render() {
        return (
            <div>
                {this.renderTabs()}

                {this.state.selectedTab === "Provider Mapping" &&
                    <ProviderMappings />
                }
                {this.state.selectedTab === "Vetdata Revenue Mapping" &&
                    <VetdataRevenueMappings />
                }
                {this.state.selectedTab === "EzyVet Revenue Mapping" &&
                    <EzyVetRevenueMappings />
                }
                {this.state.selectedTab === "Vetspire Revenue Mapping" &&
                    <VetspireRevenueMappings />
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Mappings/Mappings.js